<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('ep_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('ep_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/singin_man.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-e-engineer-sidenav :selectedItem="selectedItem"></app-e-engineer-sidenav>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('ep_button')}}</span>
            </div>

            <div class="row pview ">
              <form style="margin-top: 30px; display: contents;" name="form" @submit.self.prevent="doUpdateProfile()" onsubmit="return false;">
                <div class="col-md-3 text-center upload-btn-wrapper">
                  <video v-if="engineer_video"  height="150" width="150" controls>
                      <source :src="engineer_video">
                  </video>
                  <img class="avatar" style="width: 150px; height:150px;" v-if="cropImg" :src="cropImg" @click="editProfileImageButtonClick()" />
                  <img class="avatar" style="width: 150px; height:150px;" v-if="!cropImg && !engineer_video" src="../../assets/imgs/default-user.png" @click="editProfileImageButtonClick()" />
                  <progress-bar v-if="processUpload > 0 && !processUploadSuccess"
                    :options="options"
                    :value="processUpload"
                    />
                  <span class="camera imgbtn" @click="editProfileImageButtonClick()">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                  </span>
                  <input type="file" name="myfile" class="d-none" ref="myfile" @change="readUrl($event)" />
                </div>
                <div class="col-md-9">
                  <div class="row" style="margin-top: 15px;">
                    <div class="col-md-6 form-group input" :class="{ invalid: $v.last_name.$error }">
                        <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_lastname')}} <span style="color: red;">*</span></label>
                        <input @keydown.enter.prevent type="text" class="peditboxes peditinput form-control" name="lastname" v-model="last_name" autofocus :placeholder="$t('unify_test')" />
                         <div class="help-block" style=" margin-left: 20px;" v-if="!$v.last_name.req && lastNameFocus">{{$t('required_filed')}}</div>
                    </div>
                    <div class="col-md-6 form-group input" :class="{ invalid: $v.first_name.$error }">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_firstname')}} <span style="color: red;">*</span></label>
                      <input @keydown.enter.prevent type="text" class="peditboxes peditinput form-control" name="firstname" v-model="first_name" autofocus :placeholder="$t('unify_test')" />
                      <div class="help-block" style=" margin-left: 20px;" v-if="!$v.first_name.req && firstNameFocus">{{$t('required_filed')}}</div>
                    </div>
                  </div>

                  <div class="row" style="margin-top: 15px;">
                    <div class="col-md-6 form-group input" :class="{ invalid: $v.lastNamePhonetic.$error }">
                        <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('r_lastname_phonetic')}} <span style="color: red;">*</span></label>
                        <input @keydown.enter.prevent type="text" class="peditboxes peditinput form-control" name="lastNamePhonetic" v-model="lastNamePhonetic" autofocus :placeholder="$t('unify_test')" />
                         <div class="help-block" style=" margin-left: 20px;" v-if="!$v.lastNamePhonetic.req && lastNamePhoneticFocus">{{$t('required_filed')}}</div>
                    </div>
                    <div class="col-md-6 form-group input" :class="{ invalid: $v.firstNamePhonetic.$error }">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('r_firstname_phonetic')}} <span style="color: red;">*</span></label>
                      <input @keydown.enter.prevent type="text" class="peditboxes peditinput form-control" name="firstNamePhonetic" v-model="firstNamePhonetic" autofocus :placeholder="$t('unify_test')" />
                      <div class="help-block" style=" margin-left: 20px;" v-if="!$v.firstNamePhonetic.req && firstNamePhoneticFocus">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>


                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: jobSeekingFocus && sel_job_seeking.id == '' }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_job_seeking')}} <span style="color: red;">*</span></label>
                </div>

                <div class="col-md-9">
                  <div class="selectdiv peselectboxs form-group input" :class="{ invalid: jobSeekingFocus && sel_job_seeking.id == '' }" style="min-width: 425px;">
                    <select class="form-control" name="wantedJobType" v-model="sel_job_seeking.id" autofocus>
                      <option v-if="sel_job_seeking.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_select')}}</option>
                      <option v-for="(i,index) of job_seeking" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_job_seeking.id" :value="i.id">{{lan == 'en' ? i.en_situation : i.jp_situation}}
                      </option>
                    </select>
                     <div v-if="jobSeekingFocus && sel_job_seeking.id == ''" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: expertisFocus && sel_expertise.id == '' }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('expertise')}} <span style="color: red;">*</span></label>
                </div>

                <div class="col-md-9">
                  <div class="selectdiv peselectboxs input form-group" :class="{ invalid: expertisFocus && sel_expertise.id == '' }" style="min-width: 425px;">
                    <select class="form-control" name="wantedJobType" v-model="sel_expertise.id" autofocus>
                      <option v-if="sel_expertise.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_select')}}</option>
                      <option v-for="(i,index) of expertises" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_expertise.id" :value="i.id">{{lan == 'en' ? i.en_expertise : i.jp_expertise}}
                      </option>
                    </select>
                     <div v-if="expertisFocus && sel_expertise.id == ''" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-12 form-group">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_basic_info')}}</label>

                  <textarea rows="5" class="peditboxes pedittextarea form-control" name="profile_summary" v-model="desc" autofocus :placeholder="$t('unify_test')">

                  </textarea>
                </div>
                <div class="col-md-12" style="height: 38px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.initials.$error }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('r_initials')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 form-group input" :class="{ invalid: $v.initials.$error }">
                  <input @keydown.enter.prevent :placeholder="$t('unify_test')" v-model="initials" class="peditboxes peditinput linput form-control" name="policy" autofocus style="margin-top: 10px;" />
                  <div class="help-block" style=" margin-left: 20px;" v-if="!$v.initials.customValidation && initialsAlphaValidationFocus">{{$t('ep_initials_custom_validation')}}</div>
                  <div class="help-block" style=" margin-left: 20px;" v-if="!$v.initials.req && initialsFocus">{{$t('required_filed')}}</div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input"  :class="{ invalid: monthFocus && sel_month == '' || yearFocus && sel_year == ''  ||  dayFocus && sel_day == ''}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_bday')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9">
                  <div class="selectdiv peselectboxs input form-group" :class="{ invalid: yearFocus && sel_year == '' }" style="min-width: 128px;">
                    <select class="form-control" name="year" v-model="sel_year" autofocus>
                      <option v-if="sel_year == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of years" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_year" :value="i">{{i}}
                      </option>
                    </select>
                    <div v-if="yearFocus && sel_year == ''" class="help-block">{{$t('r_year_validation')}}</div>
                  </div>
                  <div class="selectdiv peselectboxs input form-group" :class="{ invalid: monthFocus && sel_month == '' }" style="min-width: 128px;">
                    <select class="form-control" name="month" v-model="sel_month" autofocus>
                      <option v-if="sel_month == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of months" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_month" :value="i">{{i}}
                      </option>
                    </select>
                    <div v-if="monthFocus && sel_month == ''" class="help-block">{{$t('r_month_validation')}}</div>
                  </div>
                  <div class="selectdiv peselectboxs input form-group" :class="{ invalid: dayFocus && sel_day == '' }" style="min-width: 128px;">
                    <select class="form-control" name="day" v-model="sel_day" autofocus>
                      <option v-if="sel_day == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of days" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_day" :value="i">{{i}}
                      </option>
                    </select>
                    <div v-if="dayFocus && sel_day == ''" class="help-block">{{$t('r_day_validation')}}</div>
                  </div>
                </div>
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('r_gender')}}</label>
                </div>
                <div class="col-md-9">
                  <div class="peradioboxs manradio" style="min-width: 128px;" @click="clickedSex(1)">
                    <span class="mplus2p-r peradiotxt">{{$t('ep_male')}}</span>
                  </div>
                  <div class="peradioboxs womenradio" style="min-width: 128px;" @click="clickedSex(2)">
                    <span class="mplus2p-r peradiotxt">{{$t('ep_female')}}</span>
                  </div>
                  <div class="peradioboxs otherradio" style="min-width: 128px;" @click="clickedSex(3)">
                    <span class="mplus2p-r peradiotxt">{{$t('other')}}</span>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_location')}}</label>
                </div>
                <div class="col-md-9">
                  <div v-if="sel_location != ''" class="selectdiv peselectboxs form-group" style="min-width: 425px;">
                    <select class="form-control" name="location" v-model="sel_location.id" autofocus>
                      <option v-if="sel_location.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of locations" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_location.id" :value="i.id">{{lan == 'en' ? i.en_location : i.jp_location}}
                      </option>
                    </select>
                  </div>

                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_national')}}</label>
                </div>
                <div class="col-md-9">
                  <div class="selectdiv peselectboxs form-group" style="min-width: 425px;">
                    <select class="form-control" name="location" v-model="sel_national.id" autofocus>
                      <option v-if="sel_national.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of nationals" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_national.id" :value="i.id">{{lan == "en" ? i.en_national : i.jp_national}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_languages')}}</label>
                </div>

                <div class="col-md-9">
                  <div class="form-group" style="min-width: 425px;">
                    <ul class="list-unstyled mt-3 peselectboxs form-control custom-wrapper" id="language-block">
                      <li v-for="(language,index) of languages" :key="index">
                        <label :for="'language'+language.id" class="custom-control material-checkbox">
                          <input type="checkbox" class="material-control-input" v-model="check_language[index]" :id="'language'+language.id" :value="language.id">
                          <span class="material-control-indicator"></span>
                          <span class="material-control-description">{{lan == 'en'?language.en_language:language.jp_language}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.sel_required_position.$error && requiredPositionFocus}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_required_position')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 errorClass form-group" :class="{ invalid: $v.sel_required_position.$error && requiredPositionFocus}">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group" style="min-width: 425px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="i-block">
                          <li v-for="(i,index) of required_positions" :key="index">
                            <label :for="'rtop'+i.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input" @change="errorRequiredPosition()" v-model="check_require_position[index]" :id="'rtop'+i.id" :value="i.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?i.en_required_position:i.jp_required_position}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div v-if="!$v.sel_required_position.req && requiredPositionFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.sel_requried_type_of_contract.$error && typeOfContractFocus}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack" >{{$t('ep_requried_type_of_contract')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 errorClass form-group" :class="{ invalid: $v.sel_requried_type_of_contract.$error && typeOfContractFocus}">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group " style="min-width: 425px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="rtoc-block">
                          <li v-for="(rtoc,index) of requried_type_of_contract" :key="index">
                            <label :for="'rtoc'+rtoc.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input" @change="errorCheckContract()" v-model="check_type_contract[index]" :id="'rtoc'+rtoc.id" :value="rtoc.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?rtoc.en_required_type:rtoc.jp_required_type}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div v-if="!$v.sel_requried_type_of_contract.req && typeOfContractFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.sel_required_work_area_to_be.$error && requiredWorkAreaFocus}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_required_work_area_to_be')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 errorClass" :class="{ invalid: $v.sel_required_work_area_to_be.$error && requiredWorkAreaFocus}">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group" style="min-width: 425px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="work_area-block">
                          <li v-for="(work_area,index) of ep_required_work_area_to_be" :key="index">
                            <label :for="'wantedjob'+work_area.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input"  @change="errorRequiredWorkArea()" v-model="check_work_area_to_be[index]" :id="'wantedjob'+work_area.id" :value="work_area.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?work_area.en_work_area:work_area.jp_work_area}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div v-if="!$v.sel_required_work_area_to_be.req && requiredWorkAreaFocus" style="margin-left:20px" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 ">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_desired')}}</label>
                </div>
                <div class="col-md-9 " >
                  <div class="row">
                    <div class="col-md-12">
                      <div  class="selectdiv peselectboxs form-group" style="min-width: 170px;">
                        <select class="form-control" name="experience" v-model="sel_desiar_engineer.id" autofocus>
                          <option  v-if="sel_desiar_engineer.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                          <option v-for="(i,index) of desiar_engineer" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_desiar_engineer.id" :value="i.id">{{lan == 'en' ? i.en_type : i.jp_type}}
                          </option>
                        </select>
                      </div>

                      <div class="peselectboxs form-group" style="width: 115px;">
                        <vue-numeric ref="numaric_income"  class="peditboxes numaric form-control" id="numaric_income"  separator="," v-model="income" style="height: 50px;margin-top: 5px;"></vue-numeric>
                      </div>
                      <div class="peselectboxs form-group" style="margin-top:17px;height:43px;min-width: 45px;">
                          <span>{{$t('ep_currency_unit')}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_policy')}}</label>
                </div>
                <div class="col-md-9 form-group">
                  <input @keydown.enter.prevent :placeholder="$t('unify_test')"  maxlength="45" v-model="policy" class="peditboxes peditinput linput form-control" name="policy" autofocus style="margin-top: 10px;" />
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_experience')}}</label>
                </div>
                <div class="col-md-9">
                  <div v-if="sel_experience != ''" class="selectdiv peselectboxs form-group" style="min-width: 425px;">

                    <select class="form-control" name="experience" v-model="sel_experience.id" autofocus>
                      <option v-if="sel_experience.id == ''"  class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of experiences" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_experience.id" :value="i.id">{{lan == 'en' ? i.en_experience : i.jp_experience}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_position')}}</label>
                </div>

                <div class="col-md-9">
                  <div class="selectdiv peselectboxs form-group" style="min-width: 425px;">
                    <select class="form-control" name="wantedJobCondition" v-model="sel_current_position.id" autofocus>
                      <option v-if="sel_current_position.id == ''"  class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of current_position" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_current_position.id" :value="i.id">{{lan == 'en' ? i.en_required_position : i.jp_required_position}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_type_of_contract')}}</label>
                </div>

                <div class="col-md-9">
                  <div class="selectdiv peselectboxs form-group" style="min-width: 425px;">
                    <select class="form-control" name="wantedJobCondition" v-model="selCurrentContract.id" autofocus>
                      <option v-if="selCurrentContract.id == ''"  class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of currentContract" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="selCurrentContract.id" :value="i.id">{{lan == 'en' ? i.en_required_type : i.jp_required_type}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                 <div class="col-md-12">
                   <div class="input" :class="{ invalid: experienced_corporateFocus || position_overviewFocus || started_atFocus || ended_atFocus || responsibilityFocus}">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_past_job_details')}} <span style="color: red;">*</span></label>
                   </div>
                    <div  class="textGray"  v-for="(item, index) in job_details" :key="index">
                    <div class="input" :class="{ invalid: index === 0 && experienced_corporateFocus }">
                      <div class="selectdiv dynamicSelect form-group">
                        <select  @change="experienced_corporate()" class="form-control mb-3 " name="location" v-model="item.sel_experienced_corporate" autofocus>
                          <option v-if="item.sel_experienced_corporate == ''" class="mplus2p-r black" style="font-size: 0.875rem;" :value="''">{{$t('r_select_exp_corp')}}</option>
                          <option v-for="(i,index) of experiencedCorporate" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">{{lan == "en" ? i.en_corporate : i.jp_corporate}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mb-3 input" :class="{ invalid: index === 0 && position_overviewFocus }" >
                      <input @input="positionOverview()" @keydown.enter.prevent :placeholder="$t('unify_test_pos')"  style="max-width: 805px;" maxlength="45" v-model="item.position_overview" class="peditboxes peditinput  form-control" name="policy" autofocus />
                    </div>
                    <div class="form-group" style="margin-left:1.2rem;"  >
                      <div class="row">
                        <div class='col-md-6 input' :class="{ invalid: index === 0 && started_atFocus }">
                          <date-picker @input="startDate()"  :change="startCheckDate('started_at'+index)" :id="'started_at'+index" :editable="false" :clearable="false" input-class="textGra peditboxes mx-input form-control "  width="100%" :placeholder="$t('ep_started_at')" v-model="item.started_at"  lang="en"  format="YYYY/MM"></date-picker>
                        </div>
                        <div class='col-md-6 input' :class="{ invalid: index === 0 && ended_atFocus }">
                          <date-picker @input="endDate()"  :change="endCheckDate('ended_at'+index)" :id="'ended_at'+index" :editable="false" :clearable="false" input-class="textGra peditboxes mx-input form-control "  width="100%" :placeholder="$t('ep_ended_at')" v-model="item.ended_at"  lang="en"  format="YYYY/MM"></date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 input" :class="{ invalid: index === 0 && responsibilityFocus }">
                      <textarea @input="response()"  rows="5" style="max-width: 805px;" class="enterPrevent peditboxes pedittextarea form-control" name="profile_summary" v-model="item.responsibility" autofocus :placeholder="$t('unify_test_what_resp')">
                      </textarea>
                    </div>
                      <div v-if="index === 0 && (experienced_corporateFocus || position_overviewFocus || started_atFocus || ended_atFocus || responsibilityFocus)" style="margin-left:20px;" class="help-block">{{$t('ep_past_job_details_error2')}}</div>
                      <div class="mt-1" style="margin-bottom: 60px" v-if="index !=  job_details.length - 1">
                      <button type="button" class="btn btn-danger clickcbtn"  @click.prevent="onDeleteHobby(index,item.id)" style="float: right;">
                        <i class="fa fa-trash "></i>
                      </button>
                    </div>
                  </div>
                  <div class="mt-2">
                   <button type="button" :disabled='job_details.length == 30' class="btn whitebtn clickcbtn"  @click.prevent="onAddJobDetail()" style="float: right;">
                      <i class="fa fa-plus "></i>
                    </button>
                  </div>
                 </div>

                <div class="col-md-12" style="height: 80px;"></div>
                <div class="col-md-12 pv_btnpanel">
                  <button type="submit" class="btn bluebtn updatebtn">{{$t('cp_edit_update')}}</button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="engineerProfileImage" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button>
          </div>
          <div class="modal-body m-cropper-container m-cropper-hide" style="text-align: center;">
            <div style="width: 400px; height: 300px ; display: inline-block;">
              <vue-cropper ref='cropper'
                      :guides="true"
                      :view-mode="2"
                      drag-mode="crop"

                      :auto-crop-area="1"
                      :min-container-width="400"
                      :min-container-height="300"
                      :background="false"
                      :aspectRatio= '1'
                      :zoomable="false"
                      :zoomOnTouch="false"
                      :zoomOnWheel="false"
                      :rotatable="true" :src="imgSrc" alt="Source Image" :img-style="{ 'width': '400px', 'height': '300px' }">
              </vue-cropper>
            </div>
            <p></p>
            <span class="result rounded" v-if="cropImg">
              <img class="avatar" style="width: 200px; height: 200px;" :src="cropImg">
            </span>
            <span class="result rounded" v-if="!cropImg">
              <img class="avatar" style="width: 200px; height: 200px;" src="../../assets/imgs/companydummy.png">
            </span>
            <br>
            <br>
            <button @click="cropImage" v-if="imgSrc != ''" >{{$t('cp_image_crop')}} <i class="fa fa-spinner fa-spin" v-if="cropLoader" style="font-size:18px"></i></button>
          </div>
          <div class="modal-footer">
            <button class='btn bluebtn DoneCrop' @click="uplodImage" data-dismiss="modal">{{$t('cp_done')}}</button>
          </div>
        </div>

      </div>
    </div>
    <button type="button" class="d-none" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#engineerProfileImage" ref="myBtn">
      Launch demo modal
    </button>
  </div>
</template>

<script>
if (typeof jQuery === "undefined") {
  if (typeof require === "function") {
    window.jQuery = window.$ = require("jquery");
    // Else use the dollar sign alias.
  } else {
    window.jQuery = $;
  }
}
 import {validationMixin} from "vuelidate";
  import {
    required,
    maxLength,
    minLength,
    minValue,
    sameAs
  } from "vuelidate/lib/validators";
import axios from "axios";
import ImgCropper from "vue-cropperjs";
import e_engineer_sidenav from "./e_engineer_sidenav";
import { EventBus } from "../../main.js";
import VueNumeric from 'vue-numeric'
import DatePicker from "vue2-datepicker";

const customValidation = value => {
  return /^[a-zA-Z]\.[a-zA-Z]?$/.test(value)
}
export default {
   mixins: [validationMixin],
    validations: {
      first_name: {req: required, minLength: minLength(1)},
      last_name: {req: required, minLength: minLength(1)},
      sel_year: {req: required},
      sel_month: {req: required},
      sel_day: {req: required},
      sel_job_seeking: {req: required},
      sel_expertise: {req: required},
      sel_requried_type_of_contract: {req: required},
      sel_required_position: {req: required},
      sel_required_work_area_to_be: {req: required},
      initials: {req: required, maxLength: maxLength(20), customValidation},
      firstNamePhonetic: {req: required, minLength: minLength(1)},
      lastNamePhonetic: {req: required, minLength: minLength(1)},
    },

  data() {
    return {
      selectedItem: 81,

      education: [
        {school: 'education[0][school]', program: 'education[0][program]', start: 'education[0][start]', end: 'education[0][end]'}
    ],
      firstNameFocus: false,
      lastNameFocus: false,
      firstNamePhoneticFocus: false,
      lastNamePhoneticFocus: false,
      initialsFocus: false,
      initialsAlphaValidationFocus: false,
      yearFocus: false,
      monthFocus: false,
      dayFocus: false,
      expertisFocus: false,
      typeOfContractFocus: false,
      requiredPositionFocus: false,
      requiredWorkAreaFocus: false,
      jobSeekingFocus: false,
      experienced_corporateFocus: false,
      position_overviewFocus: false,
      responsibilityFocus: false,
      started_atFocus: false,
      ended_atFocus: false,

      cropLoader: false,
      loading: false,

      job_details: [{
        sel_experienced_corporate: '',
        position_overview: '',
        responsibility: '',
        started_at: '',
        ended_at : ''
      }],

      cropImg: "",
      imgSrc: "",
      img: [],
      image: "",
      imageBlob: '',
      engineer_video:'',

      first_name: "",
      last_name: "",
      firstNamePhonetic: "",
      lastNamePhonetic: "",
      initials: "",
      locations: "",
      desc: "",
      policy: "",

      sel_year: "",
      sel_month: "",
      sel_day: "",

      sel_location: [],
      sel_experience: "",

      model: {},
      years: [],
      months: [],
      days: [],

      sex: "",

      sel_desiar_engineer: '',
      desiar_engineer: [],

      income: '',

      locations: [],
      experiences: [],

      sel_national: "",
      nationals: [],

      sel_expertise: "",
      expertises: [],

      sel_job_seeking: "",
      job_seeking: [],

      check_work_area_to_be: [],
      sel_required_work_area_to_be: '',
      ep_required_work_area_to_be: [],

      check_require_position: [],
      sel_required_position: '',
      required_positions: [],

      check_type_contract: [],
      sel_requried_type_of_contract: '',
      requried_type_of_contract: [],

      selCurrentContract: [],
      currentContract: [],

      sel_current_position: "",
      current_position: [],

      check_language: [],
      sel_language: '',
      languages: [],

      // check_contract: [],
      experiencedCorporate: [],

      roleToHandle: "",

      userId: "",
      loginUserID: "",

      lan: "jp",

      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#3d7dd8',
          backgroundColor: '#C0C0C0'
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      },
      processUpload: 0,
      processUploadSuccess: false
    };
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });

    $(this.$refs['numaric_income'].$el).keypress(function(e){
          if ( e.keyCode === 13 ) return e.preventDefault();
      });
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if ("user" in localStorage) {
      var data = JSON.parse(localStorage.getItem("user"));
      this.userId = data.id;
      this.userToken = data.user_token;
    }
    if (this.userToken != this.$route.params.uid) {
      this.$router.push("/global/PageNotFound");
    }
    this.getEngineerProfile(this.userId);
    setTimeout(() => {
      for (let i = 1950; i <= moment().format('YYYY'); i++) {
        this.years.push(i);
      }
      for (let i = 1; i <= 12; i++) {
        this.months.push(i);
      }
      for (let i = 1; i <= 31; i++) {
        this.days.push(i);
      }
    }, 1000);
  },
  components: {
    appEEngineerSidenav: e_engineer_sidenav,
    VueNumeric,
    DatePicker
  },
  methods: {
     experienced_corporate(){
        this.experienced_corporateFocus = false;
      },
     positionOverview(){
        this.position_overviewFocus = false;
      },
      startDate(){
        this.started_atFocus = false;
      },
      endDate(){
        this.ended_atFocus = false;
      },
      response(){
        this.responsibilityFocus = false;
      },
    errorCheckContract(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_type_contract.length - 1; i++) {
        if (this.check_type_contract[i]) {
          arr2.push(this.requried_type_of_contract[i].id);
        }
      }
      if (arr2.length == 0) {
        this.sel_requried_type_of_contract = ''

      }
      else{
        this.sel_requried_type_of_contract = 'ok'
        this.typeOfContractFocus = false
      }
    },
    errorRequiredPosition(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_require_position.length - 1; i++) {
        if (this.check_require_position[i]) {
          arr2.push(this.required_positions[i].id);
        }
      }
      if (arr2.length == 0) {
        this.sel_required_position = '';

      }
      else{
        this.sel_required_position = 'ok';
        this.requiredPositionFocus = false;

      }
    },
    errorRequiredWorkArea(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_work_area_to_be.length - 1; i++) {
        if (this.check_work_area_to_be[i]) {
          arr2.push(this.ep_required_work_area_to_be[i].id);
        }
      }
      if (arr2.length == 0) {
        this.sel_required_work_area_to_be = ''

      }
      else{
        this.sel_required_work_area_to_be = 'ok'
        this.requiredWorkAreaFocus = false
      }
    },
    startCheckDate(value){
      $('#'+value).keypress(function(e){

          if ( e.keyCode === 13 ) return e.preventDefault();
      });

    },
    endCheckDate(value){
      $('#'+value).keypress(function(e){
          if ( e.keyCode === 13 ) return e.preventDefault();
      });
    },
    onAddJobDetail () {
        const newJob = {
          sel_experienced_corporate: '',
          position_overview: '',
          responsibility: '',
          started_at: '',
          ended_at: '',
        }
        this.job_details.push(newJob)
      },
      onDeleteHobby (index,id) {
        if (id != undefined) {
          var formData = new FormData();
          formData.append("past_job_detail_id", id);
           axios
            .post("/delete-past-job-experience?token="+ localStorage.getItem("token"), formData)
            .then(res => {
              this.job_details.splice(index, 1)
        })
        .catch(error => console.log(error));
        }else{
          this.job_details.splice(index, 1)
        }
      },
    editProfileImageButtonClick() {
        this.$refs['myfile'].click();
    },
    getNational() {
      axios
        .get("/nationals")
        .then(res => {
          this.nationals = res.data.nationals;
        })
        .catch(error => console.log(error));
    },
    getJobSeeking() {
      axios
        .get("/job-seeking-situations")
        .then(res => {
          this.job_seeking = res.data.situations;
        })
        .catch(error => console.log(error));
    },
    getLoacation() {
      axios
        .get("/locations")
        .then(res => {
          this.locations = res.data.locations;
        })
        .catch(error => console.log(error));
    },
    getExpereance() {
      axios
        .get("/experiences")
        .then(res => {
          this.experiences = res.data.experiences;
        })
        .catch(error => console.log(error));
    },
    getFormCondition() {
      axios
        .get("/user-positions")
        .then(res => {
          this.current_position = res.data.positions;
        })
        .catch(error => console.log(error));
    },
    getWorkAreas() {
      axios
        .get("/work-areas")
        .then(res => {
          this.ep_required_work_area_to_be = res.data.work_areas;
          this.isSelectedWorkArea();
        })
        .catch(error => console.log(error));
    },
    isSelectedWorkArea(){
        for (var i = 0; i <= this.ep_required_work_area_to_be.length - 1; i++) {
        var isSelected = this.sel_required_work_area_to_be.findIndex(obj => {
          return obj.id == this.ep_required_work_area_to_be[i].id;
        });
        this.check_work_area_to_be[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getRecuiredPosition() {
      axios
        .get("/user-positions")
        .then(res => {
          this.required_positions = res.data.positions;
          this.isSelectedRecuiredPosition();
        })
        .catch(error => console.log(error));
    },
    isSelectedRecuiredPosition(){
        for (var i = 0; i <= this.required_positions.length - 1; i++) {
        var isSelected = this.sel_required_position.findIndex(obj => {
          return obj.id == this.required_positions[i].id;
        });
        this.check_require_position[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getFormType() {
      axios
        .get("/user-position-types")
        .then(res => {
          this.currentContract = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getRecuiredTypeOfContract() {
      axios
        .get("/user-position-types")
        .then(res => {
          this.requried_type_of_contract = res.data.types;
          this.isSelectedTypeContract();
        })
        .catch(error => console.log(error));
    },
    isSelectedTypeContract(){
        for (var i = 0; i <= this.requried_type_of_contract.length - 1; i++) {
        var isSelected = this.sel_requried_type_of_contract.findIndex(obj => {
          return obj.id == this.requried_type_of_contract[i].id;
        });
        this.check_type_contract[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getExperiencedCorporate() {
      axios
        .get("/experienced-corporates")
        .then(res => {
          this.experiencedCorporate = res.data.corporates;
          // this.isSelectedExperiencedCorporate();
        })
        .catch(error => console.log(error));
    },
    getLanguages() {
      axios
        .get("/engineer-languages")
        .then(res => {
          this.languages = res.data.languages;
          this.isSelectedLanguage();
        })
        .catch(error => console.log(error));
    },
    isSelectedLanguage(){
        for (var i = 0; i <= this.languages.length - 1; i++) {
        var isSelected = this.sel_language.findIndex(obj => {
          return obj.id == this.languages[i].id;
        });
        this.check_language[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getExpertises() {
      axios
        .get("/expertises?token=" + localStorage.getItem("token"))
        .then(res => {
          this.expertises = res.data.item;
        })
        .catch(error => console.log(error));
    },
    getIncomeType(){
      axios
        .get("/income-types")
        .then(res => {
            this.desiar_engineer = res.data.types;
        })
        .catch(error => console.log(error));
    },
    openModal(template) {
      this.modalRef = this.modalService.show(template);
    },

    b64toBlob(b64Data, contentTyper) {
      let contentType = contentTyper || "";
      let sliceSize = 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    convertToBlob(bsdata) {
      // Split the base64 string in data and contentType
      let block = bsdata.split(";");
      // Get the content type of the image
      let contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

      // Convert it to a blob to upload
      let blob = this.b64toBlob(realData, contentType);

      return blob;
    },

    rotateBase64Image(base64ImageSrc) {
      let canvas = document.createElement("canvas");
      let img = new Image();
      img.src = base64ImageSrc;
      canvas.width = img.width;
      canvas.height = img.height;
      let context = canvas.getContext("2d");
      context.translate(img.width, img.height);
      context.rotate(180 * Math.PI / 180);
      context.drawImage(img, 0, 0);
      return canvas.toDataURL();
    },

    clickedSex(flag) {
      if (flag === 1) {
        this.sex = 1;
        $(".womenradio").removeClass("wchosen");
        $(".otherradio").removeClass("ochosen");
        $(".manradio").addClass("mchosen");
      }
      if (flag === 2) {
        this.sex = 2;
        $(".manradio").removeClass("mchosen");
        $(".otherradio").removeClass("ochosen");
        $(".womenradio").addClass("wchosen");
      }
      if (flag === 3) {
        this.sex = 3;
        $(".manradio").removeClass("mchosen");
        $(".otherradio").addClass("ochosen");
        $(".womenradio").removeClass("wchosen");
      }
    },
    cropImage() {
      this.cropLoader = true;
      setTimeout(() => {
        this.engineer_video = ''
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.cropLoader = false;
      }, 500);

      var data = this.$refs.cropper.getCroppedCanvas({
              width: 160,
              height: 90,
              minWidth: 256,
              minHeight: 256,
              maxWidth: 4096,
              maxHeight: 4096,
              fillColor: '#fff',
              imageSmoothingEnabled: false,
              imageSmoothingQuality: 'high',
            });

      fetch(data.toDataURL( ))
        .then(obj => {
          return obj.blob();
        })
        .then(blob => {

          this.imageBlob = blob;
        });
    },
    rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    readUrl(e) {
      const file = e.target.files[0];
      // this.img.push(e.target.files[0].name);
      if (file.type === 'image/gif' || file.type === 'video/mp4') {
        this.processUploadSuccess = false;
        if (file.type === 'video/mp4') {
          if (file.size > 5242880) {
						this.$toaster.error('File size must not be more than 5 MB');
						return;
					}
          var reader = new FileReader();
          reader.onload = event => {
            this.cropImg = ''
            this.engineer_video = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }else{
          var reader = new FileReader();
          reader.onload = event => {
            this.engineer_video = ''
            this.cropImg = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }
        this.imageBlob = file
        e.target.value = '';
        return;
      }

       if (!file.type.includes("image/") || !file.type === 'image/gif' || !file.type === 'video/mp4') {
        this.$toaster.error('Please select an image or GIF or MP4 file');
        return;
      }
      if (typeof FileReader === "function") {
        var reader = new FileReader();
        reader.onload = event => {
          //vm.image = event.target.result;
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          this.showModal();
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      e.target.value = '';
    },

    showModal() {
      const elem = this.$refs.myBtn;
      elem.click();
    },

    getEngineerProfile(id) {
      this.loading = true;
      let self = this;
      axios
        .get("/user/" + id, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
              }
            }
            this.loading = false;
          } else {
            this.first_name = res.data.user.first_name;
            this.last_name = res.data.user.last_name;
            this.firstNamePhonetic = res.data.user.first_name_phonetic
            this.lastNamePhonetic = res.data.user.last_name_phonetic
            this.initials = res.data.user.initials;
            if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.engineer_video = res.data.user.image
            }else{
              this.cropImg = res.data.user.image;
            }

            this.desc = res.data.user.career_summary ;
            this.sel_year = res.data.user.birthdate_year;
            this.sel_month = res.data.user.birthdate_month;
            this.sel_day = res.data.user.birthdate_day;
            if (res.data.user.income_type_id != null) {
              this.sel_desiar_engineer =  res.data.user.income_type_id;
            } else {
              this.sel_desiar_engineer = { id: "" };
            }
            if (res.data.user.job_seeking_situation != null) {
              this.sel_job_seeking = res.data.user.job_seeking_situation;
            } else {
              this.sel_job_seeking = { id: "" };
            }
            this.income = res.data.user.income;
            this.sel_location = res.data.user.location
              ? res.data.user.location
              : { id: "" };
            this.sel_experience = res.data.user.experience
              ? res.data.user.experience
              : { id: "" };
            this.sel_expertise = res.data.user.expertise
              ? res.data.user.expertise
              : { id: "" };
            this.policy = res.data.user.policy;
            this.selCurrentContract = res.data.user.current_type_of_contract
              ? res.data.user.current_type_of_contract
              : { id: "" };

            if (res.data.user.current_position != null) {
              this.sel_current_position = res.data.user.current_position;
            } else {
              this.sel_current_position = { id: "" };
            }
            if (res.data.user.national != null) {
              this.sel_national = res.data.user.national;
            } else {
              this.sel_national = { id: "" };
            }
            this.sel_required_work_area_to_be = res.data.user.required_work_area_to_be ? res.data.user.required_work_area_to_be : [];
            this.sel_required_position = res.data.user.required_position ?res.data.user.required_position : [];
            this.sel_requried_type_of_contract = res.data.user.required_type_of_contract ? res.data.user.required_type_of_contract : [];
            this.sel_language =  res.data.user.languages ? res.data.user.languages : [];
            if (res.data.user.past_job_details.length > 0) {
              this.job_details = [];
              for (let i = 0; i < res.data.user.past_job_details.length; i++) {
                this.job_details.push(
                  {
                    id: res.data.user.past_job_details[i].id,
                    sel_experienced_corporate: res.data.user.past_job_details[i].experienced_corporate_id,
                    position_overview: res.data.user.past_job_details[i].position_overview,
                    responsibility: res.data.user.past_job_details[i].responsibility,
                    started_at: res.data.user.past_job_details[i].started_at,
                    ended_at : res.data.user.past_job_details[i].ended_at
                  }
                )
              }
               this.job_details.push(
                {
                  sel_experienced_corporate: '',
                  position_overview: '',
                  responsibility: '',
                  started_at: '',
                  ended_at : ''
                }
              )
            }

            if (res.data.user.role_to_handle != null) {
              this.roleToHandle = res.data.user.role_to_handle;
            } else {
              this.roleToHandle = "";
            }
            if (res.data.user.gender && res.data.user.gender.id == "1") {
              this.sex = "1";
              $(".womenradio").removeClass("wchosen");
              $(".manradio").addClass("mchosen");
              $(".otherradio").removeClass("ochosen");
            } else if (res.data.user.gender && res.data.user.gender.id == "2") {
              this.sex = "2";
              $(".manradio").removeClass("mchosen");
              $(".womenradio").addClass("wchosen");
              $(".otherradio").removeClass("ochosen");
            } else if (res.data.user.gender && res.data.user.gender.id == "3") {
              this.sex = "3";
              $(".manradio").removeClass("mchosen");
              $(".womenradio").removeClass("wchosen");
              $(".otherradio").addClass("ochosen");
            } else {
              $(".manradio").removeClass("mchosen");
              $(".womenradio").removeClass("wchosen");
              $(".otherradio").removeClass("ochosen");
            }
            this.getLoacation();
            this.getExpereance();
            this.getWorkAreas();
            this.getFormCondition();
            this.getFormType();
            this.getRecuiredPosition();
            this.getRecuiredTypeOfContract();
            this.getNational();
            this.getExperiencedCorporate();
            this.getLanguages();
            this.getExpertises();
            this.getJobSeeking();
            this.getIncomeType();
            setTimeout(() => {
              this.loading = false;
            }, 500);
          }
        })
        .catch(error => console.log(error));
    },
    uplodImage(){
        var formData = new FormData();
        if (this.imageBlob.type === "image/png"  || this.imageBlob.type === 'image/gif' || this.imageBlob.type === 'image/jpg' || this.imageBlob.type === 'image/jpeg') {
          formData.append("image", this.imageBlob, 'temp.png');
        }else{
            formData.append("video", this.imageBlob, this.imageBlob.name);
        }
        const vm = this
        var config = {
            onUploadProgress: function(progressEvent) {
              vm.processUpload = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            }
          };
        axios
          .post(
            "/avatar-upload?token=" + localStorage.getItem("token"),
            formData,
            config,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            },

          )
          .then(res => {
            let thisVue = this;
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
            } else {
              this.processUploadSuccess = true;
              var user = JSON.parse(localStorage.getItem("user"))
              user.image = res.data.file;
              localStorage.setItem("user", JSON.stringify(user));
              this.$toaster.success(thisVue.$t('success_file_upload'));
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    doUpdateProfile() {
      this.loading = true;
      var u_id = this.$route.params.uid;
      const thisVue = this;

      this.$v.$touch();
        if (this.$v.$invalid ) {
          this.firstNameFocus = true
          this.lastNameFocus = true
          this.firstNamePhoneticFocus = true
          this.lastNamePhoneticFocus = true
          this.initialsFocus = true
          if(this.initials != '') {
            this.initialsAlphaValidationFocus = true
          }
          this.yearFocus = true
          this.monthFocus = true
          this.dayFocus = true
          this.expertisFocus = true
          this.jobSeekingFocus = true
         if (this.job_details[0].sel_experienced_corporate == '') {
            this.experienced_corporateFocus = true;
          }
         if (this.job_details[0].position_overview == '') {
            this.position_overviewFocus = true;
          }
          if ( this.job_details[0].started_at == '') {
            this.started_atFocus = true;
          }
          if (this.job_details[0].ended_at == '' ) {
            this.ended_atFocus = true;
          }
          if (this.job_details[0].responsibility == '' ) {
            this.responsibilityFocus = true;
          }

          var required_contract = [];
          for (var i = 0; i < this.check_type_contract.length; i++) {
            if (this.check_type_contract[i]) {
              required_contract.push(this.requried_type_of_contract[i].id);
            }
          }

          if (required_contract.length == 0 ) {
            this.sel_requried_type_of_contract = '';
            this.typeOfContractFocus = true
          }

          var required_work_area_to_be = [];
          for (var i = 0; i < this.check_work_area_to_be.length; i++) {
            if (this.check_work_area_to_be[i]) {
              required_work_area_to_be.push(this.ep_required_work_area_to_be[i].id);
            }
          }
          if (required_work_area_to_be.length == 0) {
            this.sel_required_work_area_to_be = '';
            this.requiredWorkAreaFocus = true
          }

           var required_position = [];
          for (var i = 0; i < this.check_require_position.length; i++) {
            if (this.check_require_position[i]) {
              required_position.push(this.required_positions[i].id);
            }
          }
          if (required_position.length == 0) {
            this.sel_required_position = ''
            this.requiredPositionFocus = true
          }
          this.loading = false;
          setTimeout(() => {
            $('html, body').animate({scrollTop:$($('.invalid')[0]).position().top+300}, 'slow');
          },1);
        }
        else {
          if (this.job_details[0].sel_experienced_corporate == '' || this.job_details[0].ended_at == '' || this.job_details[0].position_overview == '' || this.job_details[0].responsibility == '' || this.job_details[0].started_at == '') {
           if(this.job_details[0].sel_experienced_corporate == '') {
              this.experienced_corporateFocus = true;
              $('html, body').animate({scrollTop:2880}, 'slow');
              this.loading = false;
            }
            if( this.job_details[0].position_overview == '') {
              this.position_overviewFocus = true;
              $('html, body').animate({scrollTop:2880}, 'slow');
              this.loading = false;
            }
            if( this.job_details[0].started_at == '') {
              this.started_atFocus = true;
              $('html, body').animate({scrollTop:2880}, 'slow');
              this.loading = false;
            }
            if(this.job_details[0].ended_at == '' ) {
              this.ended_atFocus = true;
              $('html, body').animate({scrollTop:2880}, 'slow');
              this.loading = false;
            }
            if(this.job_details[0].responsibility == '' ) {
              this.responsibilityFocus = true;
              $('html, body').animate({scrollTop:2900}, 'slow');
              this.loading = false;
            }
          }
          else{
            var formData = new FormData();
            formData.append("first_name", this.first_name);
            formData.append("last_name", this.last_name);
            formData.append("first_name_phonetic", this.firstNamePhonetic);
            formData.append("last_name_phonetic", this.lastNamePhonetic);
            formData.append("initials", this.initials);
            formData.append("year", this.sel_year);
            formData.append("gender_id", this.sex);
            formData.append("month", this.sel_month);
            formData.append("day", this.sel_day);
            formData.append("career_summary",  this.desc ? this.desc : '' );
            formData.append("location_id", this.sel_location.id);
            formData.append("experience_id", this.sel_experience.id);
            formData.append("job_seeking_situation_id", this.sel_job_seeking.id);
            formData.append("national_id", this.sel_national.id);
            formData.append("income_type",  this.sel_desiar_engineer.id);
            formData.append("income",  this.income );
            formData.append("policy", this.policy ? this.policy : '');
            formData.append("expertise", this.sel_expertise.id);
            formData.append("current_contract_id", this.selCurrentContract.id);
            formData.append("current_position_id", this.sel_current_position.id);
            formData.append("role_to_handle", this.roleToHandle);

          for (var i = 0; i < this.job_details.length; i++) {
            if (this.job_details[i].sel_experienced_corporate || this.job_details[i].ended_at != '' || this.job_details[i].position_overview != '' || this.job_details[i].responsibility != '' || this.job_details[i].started_at != '') {
              if (this.job_details[i].id) {
                formData.append("past_job_details[" + i + "][id]", this.job_details[i].id)
                formData.append("past_job_details[" + i + "][experienced_corporate]", this.job_details[i].sel_experienced_corporate)
                formData.append("past_job_details[" + i + "][position_overview]", this.job_details[i].position_overview)
                formData.append("past_job_details[" + i + "][responsibility]", this.job_details[i].responsibility)
                if(moment(this.job_details[i].started_at).format('YYYY/MM') > moment(this.job_details[i].ended_at).format('YYYY/MM'))
                {
                  return this.$toaster.error(i+1+'. ' + thisVue.$t('ep_date_validation'));
                }
                else{
                  formData.append("past_job_details[" + i + "][started_at]", moment(this.job_details[i].started_at).format('YYYY/MM'))
                  formData.append("past_job_details[" + i + "][ended_at]", moment(this.job_details[i].ended_at).format('YYYY/MM'))
                }
              }
              else{
                formData.append("past_job_details[" + i + "][experienced_corporate]", this.job_details[i].sel_experienced_corporate)
                formData.append("past_job_details[" + i + "][position_overview]", this.job_details[i].position_overview)
                formData.append("past_job_details[" + i + "][responsibility]", this.job_details[i].responsibility)
                if(moment(this.job_details[i].started_at).format('YYYY/MM') > moment(this.job_details[i].ended_at).format('YYYY/MM'))
                {
                  this.$toaster.error(i+1+'. ' + thisVue.$t('ep_date_validation'));
                  this.loading = false;
                  return;
                }
                else{
                  formData.append("past_job_details[" + i + "][started_at]", moment(this.job_details[i].started_at).format('YYYY/MM'))
                  formData.append("past_job_details[" + i + "][ended_at]", moment(this.job_details[i].ended_at).format('YYYY/MM'))
                }

              }
            }
          }

          var required_position = [];
          for (var i = 0; i < this.check_require_position.length; i++) {
            if (this.check_require_position[i]) {
              required_position.push(this.required_positions[i].id);
            }
          }
          for (var i = 0; i < required_position.length; i++) {
            formData.append("required_position[" + i + "]", required_position[i])
          }
          var language = [];
          for (var i = 0; i < this.check_language.length; i++) {
            if (this.check_language[i]) {
              language.push(this.languages[i].id);
            }
          }
          for (var i = 0; i < language.length; i++) {
            formData.append("language[" + i + "]", language[i])
          }
          var required_contract = [];
          for (var i = 0; i < this.check_type_contract.length; i++) {
            if (this.check_type_contract[i]) {
              required_contract.push(this.requried_type_of_contract[i].id);
            }
          }
          for (var i = 0; i < required_contract.length; i++) {
            formData.append("required_contract[" + i + "]", required_contract[i])
          }

          var required_work_area_to_be = [];
          for (var i = 0; i < this.check_work_area_to_be.length; i++) {
            if (this.check_work_area_to_be[i]) {
              required_work_area_to_be.push(this.ep_required_work_area_to_be[i].id);
            }
          }
          for (var i = 0; i < required_work_area_to_be.length; i++) {
            formData.append("required_work_area_to_be[" + i + "]", required_work_area_to_be[i])
          }

          axios
            .post(
              "/profile-edit?token=" + localStorage.getItem("token"),
              formData,
              {
                headers: { "X-localization": localStorage.getItem("lan") }
              }
            )
            .then(res => {
              if (!res.data.result) {
                if (res.data[0]) {
                  this.$toaster.error(res.data[0]);
                  this.$store.dispatch("logout");
                }
                if (res.data.errors) {
                  for (var i = 0; i < res.data.errors.length; i++) {
                    if (res.data.errors[i].field === "initials") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "income_type") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "password") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "expertise") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "job_seeking_situation_id") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "confirm_password") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "year") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "month") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "day") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    this.$toaster.error(res.data.errors[i].message);
                  }
                }
                this.loading = false;
              } else {
                this.$store.dispatch("signup", res);
                this.$router.push("/engineer/profile/" + u_id);
                this.$toaster.success(thisVue.$t("success_edit_profile"));
              }
            })
            .catch(() => {
              let thisVue = this;
              this.$toaster.error(thisVue.$t("err_network"));
            });
        }
        }
    }
  }
};
</script>

<style scoped>
/* .textGray .form-group :focus {
  color: rgb(0, 0, 0) !important
} */
.dynamicSelect{
      margin-left: 20px;
}
.textGray .form-control{
  color: gray;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}
.cropper-view-box {
    display: block;
    height: 100%;
    outline-color: rgba(51, 153, 255, 0.75);
    outline: 1px solid #39f;
    overflow: hidden;
    width: 100%;
    border-radius: 100% !important;
}

.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  border-radius: 100%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}
 .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid select{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
    .input.invalid textarea{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid .mx-datepicker {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

   .errorClass.invalid label{
    color: red
  }
  .errorClass.invalid .material-control-description{
    color: black
  }
  .errorClass.invalid .listError{
    border: 1px solid red !important;
    background-color: #ffc9aa !important;
  }
.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.camera {
  box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
  background-color: #ffffff;
  border: solid 1px #c8d2dc;
  border-radius: 100px;
  padding: 8px 9px;
  position: absolute;
  top: 105px;
  right: 30px;
  cursor: pointer;
}

.camera:hover {
  background-color: #3d7dd8;
}

.camera:hover .fa-camera {
  color: white;
}

.camera .fa-camera {
  font-size: 20px;
  color: #3d7dd8;
}

.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 20px;
}

.peditinput {
  width: 100%;
  height: 44px;
  padding: 0px 16px;
  margin-left: 20px;
}

.pedittextarea {
  width: 100%;
  padding: 16px;
  margin-left: 20px;
}

.peselectboxs {
  float: left;
  margin-left: 20px;
}

.selectdiv select {
  height: 50px !important;
}

.peradioboxs {
  text-align: center;
  min-width: 128px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 20px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}

.otherradio:hover,
.ochosen {
  border: 1px solid #5e5e5e;
  color: #5e5e5e;
}

.peradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}

.linput {
  width: 423px;
}



.form-group {
  margin-bottom: 0px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  top: 105px;
  right: 30px;
  opacity: 0;
}

.custom-control.material-checkbox {
  --color: #3d7dd8;
}

.custom-control.material-checkbox .material-control-input {
  display: none;
}

.custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
  border-color: var(--color);
  -webkit-transform: rotateZ(45deg) translate(1px, -5px);
  transform: rotateZ(45deg) translate(1px, -5px);
  width: 10px;
  border-top: 0px solid #fff;
  border-left: 0px solid #fff;
}

.custom-control.material-checkbox .material-control-indicator {
  display: inline-block;
  position: absolute;
  top: 4px;
  left: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #aaa;
  transition: 0.3s;
}

.custom-wrapper {
  width: 423px;
  max-height: 250px;
  overflow: auto;
}

@media screen and (max-width: 1200px) {
  .camera {
    top: 80px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80px;
    right: 20px;
  }
}

@media screen and (max-width: 992px) {
  .camera {
    top: 50px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 50px;
    right: 20px;
  }

  .linput {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .camera {
    top: 80%;
    right: 20%;
  }

  .peditlabel {
    margin-left: 0px;
  }

  .peditinput {
    margin-left: 0px;
  }

  .pedittextarea {
    margin-left: 0px;
  }

  .peselectboxs {
    width: 100%;
    margin-left: 0px;
  }

  .peradioboxs {
    width: 100%;
    margin-left: 0px;
  }

  .help-block {
    margin-left: 0px;
    margin-top: 10px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80%;
    right: 20%;
  }
}
</style>
